module.exports = __webpack_public_path__ + "img/xls.2cdba02.svg";